import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Calc from './components/Calc';

function App() {
  return (
    <div className="App">
      <Header/>
      <Calc/>
    </div>
  );
}

export default App;
